var NPS = {

  initNPSFeedback: function() {
    var obj = Fraction.Helpers.getDataObject("User.Persist");
    var suffix = "-" + Fraction.User.email.hashMe().toString();

    if (!obj["NPSLog" + suffix]) {
      // If NPSLog isn't set yet, save it
      obj["NPSLog" + suffix] = {};
      Fraction.Helpers.savePersist();
    }
    // TODO: Handle situations where local storage is turned off?
  },

  shouldNPSFeedbackShow: function() {
    // Make sure object is initialized
    Fraction.Helpers.initNPSFeedback();

    var shouldShow = false;
    var suffix = "-" + Fraction.User.email.hashMe().toString();
    var obj = Fraction.Helpers.getDataObject("User.Persist")["NPSLog" + suffix];

    if (
        (obj["page-views"] >= 100 ||
         obj.highlights >= 40 ||
         obj.notes >= 10 ||
         obj.searches >= 20 ||
         obj["search-clicks"] >= 20 ||
         obj.logins >= 15) &&
        !Fraction.User.nps
      ) {
      shouldShow = true;
    }

    // If shouldshow is true, mark user so they won't see again
    if (shouldShow) {
      Fraction.Helpers.setUserInfo({nps: true}, function(){
        Fraction.Helpers.getUser(function(){}, {refresh: true});
      });
    }

    return shouldShow;
  },

  logNPSFeedbackEvent: function(logType) {

    Fraction.Helpers.initNPSFeedback();

    var obj = Fraction.Helpers.getDataObject("User.Persist");
    var suffix = "-" + Fraction.User.email.hashMe().toString();

    // Increment data based on log type
    var num = parseInt(obj["NPSLog" + suffix][logType], 10);
    if (!num) {
      num = 0;
    }
    num++;
    obj["NPSLog" + suffix][logType] = num;

    // Save new data
    Fraction.Helpers.savePersist();
  }

};

module.exports = NPS;
